// extracted by mini-css-extract-plugin
module.exports = {"FormTitle":"IncidentDetails_FormTitle_2K8J_","box":"IncidentDetails_box_KFHnb"};